// Site: https://girvii.prakash-n-co.in
 const baseURL = "https://girvibackend2.prakash-n-co.in/api";
// const baseURL = "http://localhost:5061/api";
// const baseURL = "https://shashibackendb.riddhi-infotech.com/api";

//  const baseURL="https://girvibackend.prakash-n-co.in/api";
// const baseURL="https://girvibackendb.riddhi-infotech.com/api";
// const baseURL="https://sashigirvibackend.riddhi-infotech.com/api";

export default baseURL;